// extracted by mini-css-extract-plugin
export default {"mainWrapper":"OnBoardingLayout_mainWrapper__soj+U"};